import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration provided by user
const firebaseConfig = {
  apiKey: "AIzaSyDKZjUg1IXtYiDcHEKXO_Uir_vwuaXKwVs",
  authDomain: "rangaara-c6dac.firebaseapp.com",
  projectId: "rangaara-c6dac",
  storageBucket: "rangaara-c6dac.firebasestorage.app",
  messagingSenderId: "751817244870",
  appId: "1:751817244870:web:9042b28c65c01a43a4d7c7",
  measurementId: "G-7RVBL98RLD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Analytics safely (supported in browser environments)
export let analytics = null;
isSupported().then(supported => {
  if (supported) {
    analytics = getAnalytics(app);
  }
}).catch(err => {
  console.warn('Firebase Analytics not supported in this environment:', err);
});

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
